'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _d3Shape = require('d3-shape');

var _animation = require('../animation');

var _animation2 = _interopRequireDefault(_animation);

var _chartUtils = require('../utils/chart-utils');

var _theme = require('../theme');

var _scalesUtils = require('../utils/scales-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NOOP = function NOOP(d) {
  return d;
};

var ATTRIBUTES = ['angle', 'radius', 'innerRadius', 'color', 'opacity', 'fill', 'stroke'];

var ANIMATED_PROPS = ['angleDomain', 'angleRange', 'angle', 'radiusDomain', 'radiusRange', 'radius', 'innerRadiusDomain', 'innerRadiusRange', 'innerRadius', 'colorDomain', 'colorRange', 'color', 'opacityDomain', 'opacityRange', 'opacity', 'fillDomain', 'fillRange', 'fill', 'strokeDomain', 'strokeRange', 'stroke', 'data'];

var DEFAULT_MARGINS = {
  left: 10,
  right: 10,
  top: 10,
  bottom: 10
};

/**
 * Walk through the data and assign color property to the data points if it
 * doesn't exist.
 * @param {Array} data Array of data.
 * @returns {Array} New array of data points.
 */
function assignColorsToData(data) {
  return data.map(function (d, color) {
    return _extends({ color: color }, d);
  });
}

var RadialChart = function (_React$Component) {
  _inherits(RadialChart, _React$Component);

  _createClass(RadialChart, null, [{
    key: 'propTypes',
    get: function get() {
      return {
        animation: _animation.AnimationPropType,
        className: _react.PropTypes.string,
        height: _react.PropTypes.number.isRequired,
        margin: _chartUtils.MarginPropType,
        onSectionMouseOver: _react.PropTypes.func,
        onSectionMouseOut: _react.PropTypes.func,
        onSectionClick: _react.PropTypes.func,
        showLabels: _react.PropTypes.bool,
        width: _react.PropTypes.number.isRequired
      };
    }
  }, {
    key: 'defaultProps',
    get: function get() {
      return {
        className: ''
      };
    }
  }]);

  function RadialChart(props) {
    _classCallCheck(this, RadialChart);

    var _this = _possibleConstructorReturn(this, (RadialChart.__proto__ || Object.getPrototypeOf(RadialChart)).call(this, props));

    var data = assignColorsToData(props.data);
    var scaleProps = _this._getAllScaleProps(props, data);
    var arc = _this._getArcFromProps(scaleProps);
    _this.state = { scaleProps: scaleProps, data: data, arc: arc };
    return _this;
  }

  _createClass(RadialChart, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var nextData = assignColorsToData(nextProps.data);
      var nextScaleProps = this._getAllScaleProps(nextProps, nextData);
      this.setState({
        scaleProps: this._getAllScaleProps(nextProps, nextData),
        data: nextData,
        arc: this._getArcFromProps(nextScaleProps)
      });
    }

    /**
     * Triggers a callback on a section if the callback is set.
     * @param {function} handler Callback function.
     * @param {Object} d Data point of the arc.
     * @param {Object} event Event.
     * @private
     */

  }, {
    key: '_sectionHandler',
    value: function _sectionHandler() {
      var handler = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NOOP;
      var d = arguments[1];
      var event = arguments[2];
      var arc = this.state.arc;

      var _arc$centroid = arc.centroid(d),
          _arc$centroid2 = _slicedToArray(_arc$centroid, 2),
          x = _arc$centroid2[0],
          y = _arc$centroid2[1];

      handler(d.data, { event: event, x: x, y: y });
    }

    /**
     * Get the list of scale-related settings that should be applied by default.
     * @param {Object} props Object of props.
     * @returns {Object} Defaults.
     * @private
     */

  }, {
    key: '_getDefaultScaleProps',
    value: function _getDefaultScaleProps(props) {
      var _getInnerDimensions = (0, _chartUtils.getInnerDimensions)(props, DEFAULT_MARGINS),
          innerWidth = _getInnerDimensions.innerWidth,
          innerHeight = _getInnerDimensions.innerHeight;

      var radius = Math.min(innerWidth / 2, innerHeight / 2);
      return {
        radiusRange: [0, radius],
        _radiusValue: radius,
        opacityType: _theme.OPACITY_TYPE,
        _opacityValue: _theme.DEFAULT_OPACITY,
        colorRange: _theme.DISCRETE_COLOR_RANGE,
        colorType: 'category'
      };
    }

    /**
     * Get the map of scales from the props.
     * @param {Object} props Props.
     * @param {Array} data Array of all data.
     * @returns {Object} Map of scales.
     * @private
     */

  }, {
    key: '_getAllScaleProps',
    value: function _getAllScaleProps(props, data) {
      var defaultScaleProps = this._getDefaultScaleProps(props);
      var userScaleProps = (0, _scalesUtils.extractScalePropsFromProps)(props, ATTRIBUTES);
      var missingScaleProps = (0, _scalesUtils.getMissingScaleProps)(_extends({}, defaultScaleProps, userScaleProps), data, ATTRIBUTES);

      return _extends({}, defaultScaleProps, userScaleProps, missingScaleProps, {
        _allData: [],
        _adjustBy: [],
        _adjustWhat: []
      });
    }

    /**
     * Get attribute functor.
     * @param {string} attr Attribute name.
     * @returns {*} Functor.
     * @protected
     */

  }, {
    key: '_getAttributeFunctor',
    value: function _getAttributeFunctor(attr) {
      return (0, _scalesUtils.getAttributeFunctor)(this.state.scaleProps, attr);
    }

    /**
     * Extract the arc function from the props.
     * @param {Object} scaleProps Scale props.
     * @returns {function} Arc function, null if radius is missing.
     * @private
     */

  }, {
    key: '_getArcFromProps',
    value: function _getArcFromProps(scaleProps) {
      var radiusFunctor = (0, _scalesUtils.getAttributeFunctor)(scaleProps, 'radius');
      var innerRadiusFunctor = (0, _scalesUtils.getAttributeFunctor)(scaleProps, 'innerRadius');
      if (!radiusFunctor) {
        return null;
      }
      return (0, _d3Shape.arc)().outerRadius(radiusFunctor).innerRadius(innerRadiusFunctor);
    }

    /**
     * Generate the svg pie slices to be rendered
     * @param {Array} pieData - the d3 generate information for drawing slices
     * @param {Func} arc - the arc generator
     * @returns {function} the react content functor
     * @private
     */

  }, {
    key: '_renderPieSlice',
    value: function _renderPieSlice(pieData, arc) {
      var opacityFunctor = this._getAttributeFunctor('opacity');
      var fillFunctor = this._getAttributeFunctor('fill') || this._getAttributeFunctor('color');
      var strokeFunctor = this._getAttributeFunctor('stroke') || this._getAttributeFunctor('color');
      return function (d, i) {
        return _react2.default.createElement('path', {
          className: 'rv-radial-chart__series--pie__slice',
          d: arc(pieData[i]),
          style: {
            opacity: opacityFunctor && opacityFunctor(d),
            stroke: strokeFunctor && strokeFunctor(d),
            fill: fillFunctor && fillFunctor(d)
          },
          key: i
        });
      };
    }

    /**
     * Generate the svg labels to be rendered.
     * @param {Array} pieData - the d3 generate information for drawing slices
     * @returns {function} the react content functor
     * @private
     */

  }, {
    key: '_renderLabel',
    value: function _renderLabel(pieData) {
      var radiusFunctor = (0, _scalesUtils.getAttributeFunctor)(this.state.scaleProps, 'radius');
      return function (d, i) {
        // reject the label if its not affixed to the section
        var canRenderMainLabel = d.label && typeof d.label === 'string';
        var canRenderSubLabel = d.subLabel && typeof d.subLabel === 'string';
        if (!canRenderMainLabel && !canRenderSubLabel) {
          return;
        }
        // this equation finds the center of the pie wedge and place the label there
        // there is a quarter circle correction, due to where d3 places it's coord system
        var angle = (pieData[i].startAngle + pieData[i].endAngle) / 2 - Math.PI / 2;
        // we then translate a g to just outside the location of the wedge
        var xTrans = 1.1 * radiusFunctor(d) * Math.cos(angle);
        var yTrans = 1.1 * radiusFunctor(d) * Math.sin(angle);
        // finally we select which way we want the text to be oriented
        // if its on the left half of the circle, the it should be right aligned
        // and vice versa for the right half
        var textAnchor = angle > 0.5 * Math.PI && angle < 1.5 * Math.PI ? 'end' : 'start';
        return _react2.default.createElement(
          'g',
          {
            className: 'rv-radial-chart__series--pie-label-inner-wrapper',
            transform: 'translate(' + xTrans + ',' + yTrans + ')', key: i + '-text-wrapper' },
          canRenderMainLabel && _react2.default.createElement(
            'text',
            {
              className: 'rv-radial-chart__series--pie-label-primary',
              x: '0',
              y: '0',
              fontSize: '12',
              textAnchor: textAnchor
            },
            d.label
          ),
          canRenderSubLabel && _react2.default.createElement(
            'text',
            {
              className: 'rv-radial-chart__series--pie-label-secondary',
              x: '0',
              y: '15',
              fontSize: '10',
              textAnchor: textAnchor
            },
            d.subLabel
          )
        );
      };
    }

    /**
     * Generate invisible svg overlays for applying listeners to
     * @param {Array} pieData - the d3 generate information for drawing slices
     * @param {Func} arc - the arc generator
     * @returns {function} the react content functor
     * @private
     */

  }, {
    key: '_renderOverlay',
    value: function _renderOverlay(pieData, arc) {
      var _this2 = this;

      var _props = this.props,
          onSectionMouseOver = _props.onSectionMouseOver,
          onSectionMouseOut = _props.onSectionMouseOut,
          onSectionClick = _props.onSectionClick;


      return function (d, i) {
        return _react2.default.createElement('path', {
          className: 'rv-radial-chart__series--pie__slice-overlay',
          d: arc(pieData[i]),
          style: { opacity: 0 },
          onMouseEnter: function onMouseEnter(e) {
            return _this2._sectionHandler(onSectionMouseOver, pieData[i], e);
          },
          onMouseLeave: function onMouseLeave(e) {
            return _this2._sectionHandler(onSectionMouseOut, pieData[i], e);
          },
          onClick: function onClick(e) {
            return _this2._sectionHandler(onSectionClick, pieData[i], e);
          },
          key: i + '-listeners'
        });
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          animation = _props2.animation,
          className = _props2.className,
          height = _props2.height,
          showLabels = _props2.showLabels,
          width = _props2.width;


      if (animation) {
        return _react2.default.createElement(
          _animation2.default,
          _extends({}, this.props, { animatedProps: ANIMATED_PROPS }),
          _react2.default.createElement(RadialChart, _extends({}, this.props, { animation: null }))
        );
      }

      var _state = this.state,
          data = _state.data,
          arc = _state.arc;

      if (!data || !arc) {
        return null;
      }

      var pie = (0, _d3Shape.pie)().sort(null).value(function (d) {
        return d.angle;
      });
      var pieData = pie(data);
      return _react2.default.createElement(
        'div',
        {
          style: {
            width: width + 'px',
            height: height + 'px'
          },
          className: 'rv-radial-chart ' + className },
        _react2.default.createElement(
          'svg',
          {
            width: width,
            height: height,
            className: 'rv-radial-chart__svg' },
          _react2.default.createElement(
            'g',
            {
              className: 'rv-radial-chart__series--pie',
              transform: 'translate(' + width / 2 + ',' + height / 2 + ')',
              ref: 'container' },
            _react2.default.createElement(
              'g',
              { className: 'rv-radial-chart__series--pie-slices-wrapper' },
              data.map(this._renderPieSlice(pieData, arc))
            ),
            _react2.default.createElement(
              'g',
              { className: 'rv-radial-chart__series--pie-labels-wrapper' },
              showLabels && data.map(this._renderLabel(pieData))
            ),
            _react2.default.createElement(
              'g',
              { className: 'rv-radial-chart__series--pie-overlays-wrapper' },
              data.map(this._renderOverlay(pieData, arc))
            )
          )
        )
      );
    }
  }]);

  return RadialChart;
}(_react2.default.Component);

RadialChart.displayName = 'RadialChart';

exports.default = RadialChart;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-vis/dist/radial-chart/index.js
 ** module id = 810
 ** module chunks = 0
 **/